import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Upload} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import {StyledAddInvoiceButton} from './StyledAddInvoiceButton';

const uploadProps = {
  accept: '.jpeg,.jpg,.png,.pdf',
  customRequest: () => null,
  maxCount: 1,
  multiple: false,
  showUploadList: false,
}

const AddInvoiceButton = ({
  disabled = false,
  onChange,
  ...rest
}) => {
  const [t] = useTranslation('main');

  const handleUpload = ({ fileList }) => onChange?.(fileList);

  return (
    <Upload {...uploadProps} {...rest} onChange={handleUpload} disabled={disabled}>
      <StyledAddInvoiceButton
        disabled={disabled}
        icon={<PlusOutlined />}
        size='middle'
        type='text'
      >
        {t('add')}
      </StyledAddInvoiceButton>
    </Upload>
  );
}

AddInvoiceButton.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
}

export default AddInvoiceButton;
